import { Period } from "../model/Period";
import { useLivePayouts } from "./useLivePayouts";
import { useMemo } from "react";
import { ProductType } from "motty-utils";
const createBankPayouts = (payouts = [], product) => {
    const bankPayoutsSummaries = new Map();
    payouts.filter(p => p.product === product).forEach(payout => {
        let summary = bankPayoutsSummaries.get(payout.bankName);
        if (!summary) {
            summary = {
                totalAmount: payout.amount,
                totalNominalInterest: payout.nominalInterest,
                count: 1
            };
        }
        else {
            summary.totalAmount += payout.amount;
            summary.totalNominalInterest += payout.nominalInterest;
            summary.count++;
        }
        bankPayoutsSummaries.set(payout.bankName, summary);
    });
    return Array.from(bankPayoutsSummaries.entries()).map(([bank, summary]) => ({
        bank,
        avgNominal: summary.totalNominalInterest / summary.count,
        paidAmount: summary.totalAmount,
        amountOfPayouts: summary.count
    })).sort((p1, p2) => p2.paidAmount - p1.paidAmount).slice(0, 10);
};
export const useBanksPayouts = () => {
    const livePayoutsMonth = useLivePayouts(Period.Month);
    return useMemo(() => {
        const bankPayouts = {};
        bankPayouts[ProductType.ConsumerLoan] = createBankPayouts(livePayoutsMonth, ProductType.ConsumerLoan);
        bankPayouts[ProductType.CreditCard] = createBankPayouts(livePayoutsMonth, ProductType.CreditCard);
        bankPayouts[ProductType.Mortgage] = createBankPayouts(livePayoutsMonth, ProductType.Mortgage);
        return bankPayouts;
    }, [livePayoutsMonth]);
};
